<div class="row attachment-preview">
  <div class="{{uiClass}}" *ngFor="let item of attachmentList">
    <div class="employers-grid p-0">
      <div class="employers-list-logo p-0 mb-0">
        <!--for youtube video links-->
        <ng-container *ngIf="attachmentTypes.URL == item.attachmentType && item.isYoutubeVideoLink">
          <iframe class="img-size" target="_parent" allowfullscreen
            [src]="item.attachmentUIPath | formatlink: 'youtube' | safe:'resourceUrl'"></iframe>
        </ng-container>


        <ng-container *ngIf="attachmentTypes.URL == item.attachmentType && item.isAudioLink">
          <iframe class="img-size" target="_parent" allowfullscreen [src]="item.attachmentUIPath | safe:'resourceUrl'"></iframe>
        </ng-container>

        <!--for other generic links-->
        <ng-container *ngIf="attachmentTypes.URL == item.attachmentType && !item.isYoutubeVideoLink && !item.isAudioLink">
          <a href="{{item.url}}" target="_blank">
            <img class="img-fluid img-size" [src]="item.attachmentUIPath| safe:'resourceUrl'" alt="">
          </a>
        </ng-container>
        <!--for images file-->
        <ng-container *ngIf="attachmentTypes.File == item.attachmentType && item.fileType == fileTypes.Image">
          <img class="img-fluid img-size" [src]="item.attachmentUIPath | safe:'resourceUrl'" alt="">
        </ng-container>
        <!--for audio files-->
        <ng-container *ngIf="attachmentTypes.File == item.attachmentType && item.fileType == fileTypes.Audio">
          <video class="audio-size"  controls >
            <source [src]="item.attachmentUIPath | safe:'resourceUrl'" type ="audio/ogg" />
            <source [src]="item.attachmentUIPath | safe:'resourceUrl'" type ="audio/wav" />
            Your browser does not support the audio element.
         </video>
        </ng-container>
        <!--for video files-->
        <ng-container *ngIf="attachmentTypes.File == item.attachmentType && item.fileType == fileTypes.Video">
          <video class="img-size" controls >
            <source [src]="item.attachmentUIPath | safe:'resourceUrl'" type ="video/ogg" />
            <source  [src]="item.attachmentUIPath| safe:'resourceUrl'" type ="video/mp4" />
            Your browser does not support the video element.
          </video>
        </ng-container>
        <!--for document files-->
        <ng-container *ngIf="attachmentTypes.File == item.attachmentType && item.fileType == fileTypes.Document">
          <!-- <iframe [src]="item.attachmentUIPath | safe: 'resourceUrl'"></iframe> -->
          <ngx-doc-viewer [url]="item.attachmentUIPath" viewer="google"
            style="height: -webkit-fill-available;width: -webkit-fill-available"></ngx-doc-viewer>

        </ng-container>
      </div>
      <div class="employers-list-details">
        <div class="employers-list-info">
          <small class="mb-0 text-dark">{{item.title}}</small>
          <small *ngIf="canDelete" class="mb-0 text-dark float-right cursor-pointer" (click)="handleOnDeleteAttachment(item.attachmentId)">
            <i class="far fa-trash-alt text-danger"></i>
          </small>
        </div>
      </div>
    </div>
  </div>
</div>
